import { useTranslation } from "react-i18next";
import { Icon, Label, Popup } from "semantic-ui-react";

import { DATE_FORMATS_FNS, useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { MANUFACTURER_REQUEST_STATUSES } from "models/Manufacturer";
import "modules/ManufacturerDashboard/components/ManufacturerStatus/ManufacturerStatus.scss";
import { formatDate } from "utils/dateHelperFunctions";

import type { ManufacturerRequest } from "models/Manufacturer";

type ManufacturerStatusPropTypes = {
  request: ManufacturerRequest | null;
  openRequestModal: (request: ManufacturerRequest) => void;
};

export const ManufacturerStatus = ({ request, openRequestModal }: ManufacturerStatusPropTypes) => {
  const { t } = useTranslation();

  const canHandleRequest = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.ManufacturerRequest);

  if (!request) return <div />;

  if (request.status === MANUFACTURER_REQUEST_STATUSES.Approved) {
    if (!request.expire_on)
      return (
        <Label className="Manufacturer__status-approved Manufacturer__status">
          <Icon className="check" />
        </Label>
      );

    const message = `${t("v8_this_access_will_expire_on", "This access will expire on:")}  ${formatDate(request.expire_on, DATE_FORMATS_FNS.dateMonthYear)}`;
    return (
      <Popup
        trigger={
          <Label className="Manufacturer__status-approved Manufacturer__status">
            <Icon className="check" />
          </Label>
        }
        content={message}
      />
    );
  }
  if (request.status === MANUFACTURER_REQUEST_STATUSES.Declined) {
    const message = `${t("v8_declined_for_the_following_reason", "Declined for the following reason:")} ${request.decline_reason}`;
    return (
      <Popup
        trigger={
          <Label className="Manufacturer__status-declined Manufacturer__status">
            <Icon className="x mark" />
          </Label>
        }
        content={message}
      />
    );
  }

  const message = canHandleRequest
    ? `${request.manufacturer?.first_name} ${request.manufacturer?.last_name} ${t("v8_requested_access_for_the_following_reason", "requested access for the following reason:")} ${request.request_reason}`
    : t("v8_request_pending_approval", "Request pending approval");

  return (
    <span
      onClick={() => {
        if (!canHandleRequest) return;
        openRequestModal(request);
      }}
    >
      <Popup
        trigger={
          <Label className="Manufacturer__status-pending Manufacturer__status">
            <Icon className={canHandleRequest ? "question" : "clock rotate left"} />
          </Label>
        }
        content={message}
      />
    </span>
  );
};
